$(document).ready(function () {
    const hospitalFinder = (function ($) {
        window.dataLayer = window.dataLayer || [];
        const mapData = {
            self: null,
            map: null,
            maptype: null,
            currentPage: 1,
            infowindow: null,
            markers: [],
            infoWindows: [],
            date: null,
            postcode: null,
            data: null,
            directionsDisplay: null,
            directionsService: null,
            baseMarker: null,
            hospitalMarker: null,
            hospitalData: null,
            hospitalList: [],
            myHospitalList: [],
            element: {
                yourLocationPopover: '#hospital-your-location',
                hospitalInfoPopover: '#hospital-info-popover'
            },

            initMap: function (data) {
                this.directionsService = new google.maps.DirectionsService();
                const directionsRenderer = new google.maps.DirectionsRenderer();

                const location = {lat: data.userSearchCoordinates.latitude, lng: data.userSearchCoordinates.longitude};
                const map = new google.maps.Map(document.getElementById('mapview'), {
                    zoom: 10,
                    center: location,
                    mapTypeId: google.maps.MapTypeId.ROADMAP
                });

                const contentString = $(mapData.element.yourLocationPopover).html();

                const infowindow = new google.maps.InfoWindow({
                    content: contentString
                });

                const marker = new google.maps.Marker({
                    position: location,
                    map: map,
                    icon: '/Assets/images/home_map.jpeg'
                });
                marker.addListener('click', function () {
                    infowindow.open(map, marker);
                });
                this.setMarkers(map, data);
                directionsRenderer.setMap(map);
            },
            setMarkers: function (map, data) {
                const image = {
                    url: '/Assets/images/icon_hosp.png'
                };

                const mapDataInfosettings = $(mapData.element.hospitalInfoPopover).html();
                for (let i = 0; i < data.mapRecords.length; i++) {
                    let contentString = mapDataInfosettings.replace('[name]', data.mapRecords[i].name);
                    contentString = contentString.replace('[address]', data.mapRecords[i].address);
                    contentString = contentString.replace('[distance]', data.mapRecords[i].distance);
                    contentString = contentString.replace('[postcode]', data.mapRecords[i].postcode);

                    const hospitalmarker = new google.maps.Marker({
                        position: {lat: data.mapRecords[i].latitude, lng: data.mapRecords[i].longitude},
                        map: map,
                        mapTypeId: google.maps.MapTypeId.ROADMAP,
                        info: contentString,
                        icon: image
                    });

                    const infowindow3 = new google.maps.InfoWindow();
                    google.maps.event.addListener(hospitalmarker, 'mouseover', function () {
                        infowindow3.setContent(this.info);
                        infowindow3.open(map, this);
                    });
                }
            },
            getdirection: function (startlat, startlong, endlat, endlong) {
                const self = this;
                const request = {
                    origin: new window.google.maps.LatLng(startlat, startlong),
                    destination: new window.google.maps.LatLng(endlat, endlong),
                    travelMode: google.maps.TravelMode.DRIVING
                };
                const location = {lat: +startlat, lng: +startlong};
                const map = new google.maps.Map(document.getElementById('mapview'), {
                    zoom: 10,
                    center: location,
                    mapTypeId: google.maps.MapTypeId.ROADMAP
                });
                self.directionsDisplay = new google.maps.DirectionsRenderer(
                    {
                        map: map,
                        suppressMarkers: true
                    });
                self.directionsService.route(request, function (response, status) {
                    if (status === google.maps.DirectionsStatus.OK) {
                        self.directionsDisplay.setDirections(response);
                        const leg = response.routes[0].legs[0];
                        new google.maps.Marker({
                            position: leg.start_location,
                            map: map,
                            icon: '/Assets/images/home_map.jpeg'
                        });
                        new google.maps.Marker({
                            position: leg.end_location,
                            map: map,
                            icon: '/Assets/images/icon_hosp.png'
                        });
                    }
                });
            },
            deleteOverlays: function () {
                this.map = new google.maps.Map(document.getElementById('mapview'), {});
                if (this.map.markers) {
                    this.map.markers.length = 0;
                }
            },
            createMarker: function (content, latlng, icon) {
                const marker = new window.google.maps.Marker({
                    position: latlng,
                    map: this.map,
                    icon: icon
                });
                window.google.maps.event.addListener(marker, 'click', function () {
                    if (mapData.self.infowindow) {
                        mapData.self.infowindow.close();
                    }
                    mapData.self.infowindow = new window.google.maps.InfoWindow({content: content});
                    mapData.self.infowindow.open(this.map, marker);

                });
                mapData.markers.push(marker);
                return marker;
            }
        };

        const autoComplete = {
            loadAutoComplete: function (inp, arr) {
                let currentFocus;
                inp.addEventListener('input', function () {
                    const val = this.value;
                    closeAllLists();

                    if (val.length > 2) {
                        loadAutoCompleteData(val, this);
                    }
                });

                inp.addEventListener('keydown', function (e) {
                    const x = getAutoCompleteElement(this.id);
                    keyCodeDown(e.keyCode, x);
                    keyCodeUp(e.keyCode, x)
                    if (e.keyCode === 13) {
                        e.preventDefault();
                        if (currentFocus > -1 && x) {
                            x[currentFocus].click();
                        }
                    }
                });

                function loadAutoCompleteData(val, element) {
                    let a;
                    let b;
                    let i;
                    currentFocus = -1;
                    a = document.createElement('DIV');
                    a.setAttribute('style', 'position: absolute;border: 1px solid #d4d4d4;border-bottom: none;' +
                        'border-top: none;z-index: 99;top: 100 %;left: 0;right: 0;padding: 10px;cursor: pointer;' +
                        'background-color: #fff; border-bottom: 1px solid #d4d4d4;');
                    a.setAttribute('class', 'autocomplete-items');
                    element.parentNode.appendChild(a);
                    for (i = 0; i < arr.length; i++) {
                        if (arr[i].substr(0, val.length).toUpperCase() === val.toUpperCase()) {
                            b = document.createElement('DIV');
                            b = document.createElement('DIV');

                            const strong = document.createElement('strong');
                            strong.textContent = arr[i].substr(0, val.length);

                            const remainingText = document.createTextNode(
                                arr[i].substr(val.length)
                            );

                            b.appendChild(strong);
                            b.appendChild(remainingText);

                            b.addEventListener('click', function () {
                                inp.value = arr[i];
                                closeAllLists();
                            });

                            a.appendChild(b);
                        }
                    }
                }

                function keyCodeDown(keyCode, x) {
                    if (keyCode === 40) {
                        currentFocus++;
                        addActive(x);
                    }
                }

                function keyCodeUp(keyCode, x) {
                    if (keyCode === 38) {
                        currentFocus--;
                        addActive(x);
                    }
                }

                function getAutoCompleteElement(id) {
                    let x = document.getElementById(id + 'autocomplete-list');

                    if (x) {
                        x = x.getElementsByTagName('div');
                    }

                    return x;
                }

                function addActive(x) {
                    if (!x) {
                        return false;
                    }
                    removeActive(x);
                    if (currentFocus >= x.length) {
                        currentFocus = 0;
                    }
                    if (currentFocus < 0) {
                        currentFocus = (x.length - 1);
                    }

                    x[currentFocus].classList.add('autocomplete-active');

                    return true;
                }

                function removeActive(x) {
                    for (let i = 0; i < x.length; i++) {
                        x[i].classList.remove('autocomplete-active');
                    }
                }

                function closeAllLists(elmnt) {
                    const x = document.getElementsByClassName('autocomplete-items');
                    for (let i = 0; i < x.length; i++) {
                        if (elmnt !== x[i] && elmnt !== inp) {
                            x[i].parentNode.removeChild(x[i]);
                        }
                    }
                }

                document.addEventListener('click', function (e) {
                    closeAllLists(e.target);
                });
            }
        };

        var self = {
            postCodeRegex: /^(GIR ?0AA|[A-PR-UWYZa-pr-uwyz]([0-9]{1,2}|([A-HK-Ya-hk-y][0-9]([0-9ABEHMNPRV-Yabehmnprv-y])?)|[0-9][A-HJKPS-UWa-hjkps-uw]) ?[0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})$/,
            hospitalData: null,
            ajax: {
                get: 'GET',
                contentType: 'application/json',
                dataType: 'json'
            },
            element: {
                textBox: {
                    postCode: '#hospital-finder-postcode',
                    hospitalName: '#hospital-finder-name'
                },
                button: {
                    searchBox: '#searchbutton'
                },
                validation: {
                    hospitalSearchNoResult: '#hospital-search-no-result',
                    postCodeValidation: '#hospital-finder-postcodevalidation'
                },
                render: {
                    hospitalDetailsRow: '#hospital-info-details-row',
                    hospitalList: '#hospital-list'
                }
            },
            pagination: {
                innerHtml: '.vds-pagination__inner',
                item: {
                    total: '.pagination_total_item'
                },
                pageNumber: {
                    current: '.pagination_current_page_number',
                    total: '.pagination_total_page_number',
                    selected: '.pagination_selected_page_number'
                },
                button: {
                    disabled: 'vds-pagination__page-toggle--disabled',
                    nextPage: '.vds-pagination__page-toggle--next',
                    previous: '.vds-pagination__page-toggle--previous'
                },
                pageSize: '.pagination_current_item_size'
            },
            func: {
                init: function () {
                    $('#mapview').show();
                    $(self.element.validation.postCodeValidation).hide();
                    self.func.bindEvent();
                    self.func.loadData();
                },
                bindDynamicEvent: function () {
                    $('a.address-wrp').on('click', self.func.getDirectionClick);
                },
                bindEvent: function () {
                    $('.vds-pagination__toggle--items .vds-form__custom-select').on('change',
                        self.func.pageSizeOnChange);
                    $(self.pagination.button.previous).on('click',
                        self.func.openPreviousPage);
                    $(self.pagination.button.nextPage).on('click',
                        self.func.openNextPage);
                    $('.vds-pagination__toggle--pages .vds-form__custom-select').on('change',
                        self.func.pageNumberOnChange);
                    $(self.element.button.searchBox).on('click', self.func.searchOnClick);
                    $(self.element.textBox.hospitalName).on('input', self.func.hospitalNameSearch);
                    $(self.element.textBox.hospitalName).on('blur', self.func.validateSearch);
                    $(self.element.textBox.postCode).on('blur', self.func.validateSearch);
                },
                getDirectionClick: function () {
                    const startlat = $(this).attr('startlat');
                    const startlong = $(this).attr('startlong');
                    const endlat = $(this).attr('lat');
                    const endlong = $(this).attr('long');

                    mapData.getdirection(startlat, startlong, endlat, endlong);
                },
                hospitalNameSearch: function (e) {
                    if (this.value.length > 1 && self.func.validateSearch()) {
                        $(self.element.validation.postCodeValidation).hide();
                        e.preventDefault();

                        jQuery.ajax({
                            type: self.ajax.get,
                            url: self.func.getHospitalDetailsUrl(),
                            contentType: self.ajax.contentType,
                            dataType: self.ajax.dataType,
                            success: function (data) {
                                self.func.loadAutoCompleteHospital(data);
                            }
                        });
                    }
                },
                validateSearch: function () {
                    let isValid = self.func.checkHospitalNameSearch();
                    isValid = self.func.checkPostcodeSearch(isValid);

                    if (isValid) {
                        $(self.element.validation.postCodeValidation).hide();
                        $(self.element.button.searchBox).removeClass('vds-button--disabled');
                    } else {
                        $(self.element.validation.postCodeValidation).show();
                        $(self.element.button.searchBox).addClass('vds-button--disabled');
                    }

                    return isValid;
                },
                searchOnClick: function (e) {
                    if (self.func.validateSearch()) {
                        self.func.loadData();
                    }

                    e.preventDefault();
                },
                pageNumberOnChange: function () {
                    const currentPageSize = self.func.getCurrentPageSize(self.hospitalData.mapRecords);
                    const currentPageNumber = self.func.getSelectedPageNumber(this);

                    self.func.showTable(currentPageNumber, currentPageSize);
                },
                pageSizeOnChange: function () {
                    const currentPageSize = self.func.getSelectedPageSize(this, self.hospitalData.mapRecords);
                    self.func.setTable(currentPageSize);

                    const currentPageNumber = 1;

                    self.func.showTable(currentPageNumber, currentPageSize);
                },
                openPreviousPage: function () {
                    const currentPageSize = self.func.getCurrentPageSize(self.hospitalData.mapRecords);
                    const currentPageNumber = self.func.getCurrentPageNumber();

                    const previousPageNumber = Number(currentPageNumber) - 1;
                    if (previousPageNumber >= 1) {
                        self.func.showTable(previousPageNumber, currentPageSize);
                    }
                },
                openNextPage: function () {
                    const currentPageSize = self.func.getCurrentPageSize(self.hospitalData.mapRecords);
                    const currentPageNumber = self.func.getCurrentPageNumber();

                    const nextPageNumber = Number(currentPageNumber) + 1;
                    if (nextPageNumber <= self.func.getTotalPageNumber(self.hospitalData.mapRecords,
                        currentPageSize)) {
                        self.func.showTable(nextPageNumber, currentPageSize);
                    }
                },
                paginate: function (array, pageNumber, pageSize) {
                    self.func.setCurrentPageNumber(pageNumber);

                    return array.slice((pageNumber - 1) * pageSize, pageNumber * pageSize);
                },
                getTotalPageNumber: function (array, pageSize) {
                    let i = 0;
                    let pageNumber = 0;

                    while (i < array.length) {
                        i += Number(pageSize);
                        pageNumber += Number(1);
                    }

                    return pageNumber
                },
                setValue: function (element, value) {
                    $(element).data('value', value);
                    $(element).children().html(value);
                },
                getCurrentPageNumber: function () {
                    return Number($($(self.pagination.pageNumber.current)[0]).text());
                },
                setCurrentPageNumber: function (pageNumber) {
                    $(self.pagination.pageNumber.current).text(pageNumber);
                    $($(self.pagination.pageNumber.selected).children()).text(pageNumber);
                    const siblingElement = $(self.pagination.pageNumber.selected).siblings();
                    $(siblingElement).find('input:radio').prop('checked', false);
                    $($(siblingElement).find('#selectdownpageradio-' + pageNumber)[0]).prop("checked", true);
                    $($(siblingElement).find('#selectuppageradio-' + pageNumber)[0]).prop("checked", true);
                },
                setTotalPageNumber: function (pageNumber) {
                    $(self.pagination.pageNumber.total).text(pageNumber);
                },
                setTotalItems: function (itemsCount) {
                    $(self.pagination.item.total).text(itemsCount);
                },
                getCurrentPageSize: function (array) {
                    let pageSize = array.length;
                    if ($(self.pagination.pageSize).children().text() !== 'All') {
                        pageSize = $($(self.pagination.pageSize).children()[0]).text();
                    }

                    return Number(pageSize);
                },
                getSelectedPageSize: function (element, array) {
                    let pageSize = $($(element).find(self.pagination.pageSize)).children().text();
                    self.func.setCurrentPageSize(pageSize);

                    if ($($(element).find(self.pagination.pageSize)).children().text() === 'All') {
                        pageSize = array.length;
                    }

                    return Number(pageSize);
                },
                getSelectedPageNumber: function (element) {
                    const pageSize = $($(element).find(self.pagination.pageNumber.selected)).children().text();

                    return Number(pageSize);
                },
                setCurrentPageSize: function (pageSize) {
                    self.func.setValue(self.pagination.pageSize, pageSize);
                },
                validateNextPageLink: function (currentPageNumber, totalPage) {
                    if (currentPageNumber >= totalPage) {
                        $(self.pagination.button.nextPage).addClass(self.pagination.button.disabled);
                    } else {
                        $(self.pagination.button.nextPage).removeClass(self.pagination.button.disabled);
                    }
                },
                validatePreviousPageLink: function (currentPageNumber) {
                    if (currentPageNumber <= 1) {
                        $(self.pagination.button.previous).addClass(self.pagination.button.disabled);
                    } else {
                        $(self.pagination.button.previous).removeClass(self.pagination.button.disabled);
                    }
                },
                loadAutoCompleteHospital: function (data) {
                    const hospitalNames = [];

                    if (data !== null) {
                        for (let i = 0; i < data.mapRecords.length; i++) {
                            hospitalNames.push(data.mapRecords[i].name);
                        }

                        autoComplete.loadAutoComplete($(self.element.textBox.hospitalName)[0], hospitalNames);
                    }
                },
                validatePostCode: function (isValid) {
                    if (!isValid && $(self.element.textBox.postCode).val() === '') {
                        isValid = false;
                    } else {
                        isValid = true;
                    }

                    return isValid;
                },
                checkPostcodeSearch: function (isValid) {
                    isValid = self.func.validatePostCode(isValid);

                    if ($(self.element.textBox.postCode).val() !== '') {
                        const postcodes = $(self.element.textBox.postCode).val().match(self.postCodeRegex);

                        if (postcodes === null) {
                            isValid = false
                        }
                    }

                    return isValid;
                },
                checkHospitalNameSearch: function () {
                    let isValid = false;
                    if ($(self.element.textBox.hospitalName).val() !== '') {
                        isValid = true;
                    }

                    return isValid;
                },
                setTable: function (pageSize) {
                    const pagenumberLabel = '.vds-pagination__pages .vds-form__custom-select'
                        + ' .vds-form__select-container .vds-form__select-label';
                    self.func.setTotalItems(self.hospitalData.mapRecords.length);
                    $(pagenumberLabel).hide();
                    let i = 0;
                    let pageNo = 0;

                    while (i < self.hospitalData.mapRecords.length) {
                        i += Number(pageSize);
                        pageNo += Number(1);
                        $('#selectuppageradio-label-' + pageNo).show();
                        $('#selectdownpageradio-label-' + pageNo).show();
                    }

                    self.func.setCurrentPageNumber(1);
                },
                updateField: function (pageData, fieldName, value) {
                    return pageData.replace(fieldName, value);
                },
                loadHospitalList: function (currentPageNumber, currentPageSize) {
                    const currentPageHospitalList = self.func.paginate(self.hospitalData.mapRecords,
                        currentPageNumber, currentPageSize);
                    $('#hospital-category').text(self.hospitalData.hopitalCategory);
                    $('#hospital-category').parent().prop('title', self.hospitalData.hopitalCategory);
                    let hospitalDetailsettings = $(self.element.render.hospitalDetailsRow).html();
                    hospitalDetailsettings = self.func.updateField(hospitalDetailsettings,
                        '[startlatitude]', self.hospitalData.userSearchCoordinates.latitude);
                    hospitalDetailsettings = self.func.updateField(hospitalDetailsettings,
                        '[startlongitude]', self.hospitalData.userSearchCoordinates.longitude);
                    hospitalDetailsettings = self.func.updateField(hospitalDetailsettings,
                        '[category]', self.hospitalData.hopitalCategory);
                    let hospitalListHtml = '';

                    for (let i = 0; i < currentPageHospitalList.length; i++) {
                        let hospitalDetails = hospitalDetailsettings;
                        hospitalDetails = self.func.updateField(hospitalDetails,
                            '[address]', currentPageHospitalList[i].address);
                        hospitalDetails = self.func.updateField(hospitalDetails,
                            '[postcode]', currentPageHospitalList[i].postcode);
                        hospitalDetails = self.func.updateField(hospitalDetails,
                            '[name]', currentPageHospitalList[i].name);
                        hospitalDetails = self.func.updateField(hospitalDetails,
                            '[distance]', currentPageHospitalList[i].distance);
                        hospitalDetails = self.func.updateField(hospitalDetails,
                            '[latitude]', currentPageHospitalList[i].latitude);
                        hospitalDetails = self.func.updateField(hospitalDetails,
                            '[longitude]', currentPageHospitalList[i].longitude);
                        hospitalListHtml += hospitalDetails;
                    }
                    $(self.element.render.hospitalList).html(hospitalListHtml);
                },
                showEmptyTable: function () {
                    $(self.pagination.innerHtml).hide();
                    $(self.element.validation.hospitalSearchNoResult).show();
                    $(self.element.render.hospitalList).hide();
                },
                showTable: function (currentPageNumber, currentPageSize) {
                    mapData.initMap(self.hospitalData);
                    $(self.element.render.hospitalList).show();
                    self.func.loadHospitalList(currentPageNumber, currentPageSize);
                    const totalPage = self.func.getTotalPageNumber(self.hospitalData.mapRecords,
                        currentPageSize);
                    self.func.setCurrentPageNumber(currentPageNumber);
                    self.func.setTotalPageNumber(totalPage);
                    self.func.validateNextPageLink(currentPageNumber, totalPage);
                    self.func.validatePreviousPageLink(currentPageNumber);
                },
                loadHospitalDetails: function (data) {
                    if (data.isSuccess) {
                        mapData.hospitalData = data;
                        mapData.hospitalList = data.mapRecords;
                        self.hospitalData = data;
                        mapData.initMap(data);
                        const pageSize = self.func.getCurrentPageSize(self.hospitalData.mapRecords);
                        self.func.setTable(pageSize);
                        self.func.showTable(1, pageSize);
                        $(self.element.validation.hospitalSearchNoResult).hide();
                        if (mapData.hospitalData.mapRecords.length <= 9) {
                            $(self.pagination.innerHtml).hide();
                        } else {
                            $(self.pagination.innerHtml).show();
                        }
                        self.func.bindDynamicEvent();
                    } else {
                        self.func.showEmptyTable();
                    }
                },
                loadData: function () {
                    mapData.deleteOverlays();
                    jQuery.ajax({
                        type: self.ajax.get,
                        url: self.func.getHospitalDetailsUrl(),
                        contentType: self.ajax.contentType,
                        dataType: self.ajax.dataType,
                        success: function (data) {
                            self.func.loadHospitalDetails(data);
                        },
                        error: function () {
                            window.location.href = '/error/error-page';
                        }
                    });
                },
                getHospitalDetailsUrl: function () {
                    return '/api/sitecore/HospitalFinder/SearchHospitals?postCode='
                        + $(self.element.textBox.postCode).val() + '&hospitalName='
                        + $(self.element.textBox.hospitalName).val()
                }
            }
        }

        return {
            init: self.func.init
        };
    })(jQuery);

    if ('hospitalfinder' === $('#mapview').data('page')) {
        hospitalFinder.init();
    }
});
